<template lang="html">
  <div>
    <h1>{{beer.name}}</h1>
    <img :src="require('../assets/beers/beer_id-' + (beer.id || 1) + '.png')" alt="">
    <div class="std-info">
      <p>abv. {{beer.abv}}%</p>
      <p>kr. {{beer.price}}.00</p>
    </div>
    <div class="user-info">
      <label for="rating">Rating:</label>
      <select class="" name="rating" v-model="beer.rating">
        <option v-for="n of [1,2,3,4,5]" :key="n.index" :value="n">{{n}}</option>
      </select>
      <label for="comment">Kommentar</label>
      <textarea name="comment" v-model="beer.comment"></textarea>
      <p>drukket: {{displayDate}}</p>
    </div>
    <div class="button-container">
      <a href="#">
        <ActionButton v-if="hasdrinked"
          @click-action="updateBeer"
          title="Updatér!">
        </ActionButton>
      </a>

    </div>

    <div class="button-container">
      <ActionButton v-if="!hasdrinked"
        @click-action="registerBeer"
        title="Jeg har drukket den!">
      </ActionButton>
      <a v-else
        href="#"
        @click="unregisterBeer">Jeg har glemt den!
      </a>
    </div>


  </div>
</template>

<script>
import ActionButton from '@/components/ActionButton.vue';
import axios from 'axios';
export default {
  name: 'BeerPage',
  components:{
    ActionButton
  },
  props: {
    beer: Object,
    user: Object,
  },
  data: function(){
    let hasdrinked = false;
    if(this.beer.date){
      hasdrinked = true;
    }
    return {
      hasdrinked,
    }
  },
  computed: {
    displayDate: function() {
      if(this.beer.date){
        return new Date(this.beer.date).toLocaleString('da', {dateStyle: 'long', timeStyle: 'short'});
      }
      return '';
    }
  },
  methods: {
    updateBeer(){
      console.log(this.beer.comment);
      axios.post('https://klogtkryds.dk/studenterbaren/api/updateBeer', {
        id_token: this.user.id_token,
        beer_id: this.beer.id,
        beer_rating: this.beer.rating,
        beer_comment: this.beer.comment

      })
      .then(res => {
        console.log(res);
      });
    },
    registerBeer(){
      axios.post('https://klogtkryds.dk/studenterbaren/api/registerBeer', {
        id_token: this.user.id_token,
        beer_id: this.beer.id
      })
      .then(res => {
        this.beer.date = new Date();
        this.hasdrinked = true;
        console.log(res);
      });

    },
    unregisterBeer(){
      axios.post('https://klogtkryds.dk/studenterbaren/api/unregisterBeer', {
        id_token: this.user.id_token,
        beer_id: this.beer.id
      })
      .then(res => {
        this.beer.date = false;
        this.hasdrinked = false;
        console.log(res);
      });
    },
  }
}
</script>

<style lang="css" scoped>
  div {
    display: flex;
    flex-direction: column;
  }
  img{
    width: 100%;
    height: 200px;
    object-fit: contain;
    padding-top: 10px;
    box-sizing: border-box;
    margin-bottom: 40px;
  }
  p{
    margin: 5px;
    margin-left: 20px;
    margin-right: 20px;

  }
  .std-info{
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin: auto;
  }
  .button-container{
    max-width: 300px;
    margin: 20px auto;
    margin-top: 50px;
  }
  textarea, select{
    width: 90%;
    margin: auto;
    text-align-last:center;
    text-align: center;
  }
  a{
    color: inherit;
  }
</style>
